import type { StateDeclarationFn } from 'controller/types';

export default [
  require('./members-area-groups.route').default,
  require('./my-groups.route').default,
  require('./my-posts.route').default,
] as StateDeclarationFn[];
